import React, { memo, useCallback } from 'react';

import shareFacebook from 'assets/image/share-facebook.png';
import shareInstagram from 'assets/image/share-instagram.png';
import shareTwitter from 'assets/image/share-twitter.png';
import downloadAndroid from 'assets/image/download-android.png';

import Analytics from 'app/lib/Analytics/Analytics';
import styles from './DownloadAndroid.module.css';

interface IDownloadAndroid {
}

const DownloadAndroid: React.FC<IDownloadAndroid> = memo((props) => {
  const handleFollowFacebook = useCallback(() => {
    Analytics.track().tappedFacebookFollow();
  }, []);

  const handleFollowInstagram = useCallback(() => {
    Analytics.track().tappedInstagramFollow();
  }, []);

  const handleFollowTwitter = useCallback(() => {
    Analytics.track().tappedTwitterFollow();
  }, []);

  const handleDownloadAndroid = useCallback(() => {
    Analytics.track().tappedCreateYourOwn();
  }, []);

  return (
    <div className={styles.steps}>
      <div className={styles.header}>
        Get More Smiles on
        <br />
        Social Media
      </div>
      <div className={styles.follow}>
        <div className={styles.followTitle}>Follow us:</div>
        <div className={styles.followIcons}>
          <div className={styles.followIcon}>
            <a
              href="https://www.facebook.com/CardSnacks/"
              onClick={handleFollowFacebook}
              target="_blank"
              rel="noreferrer"
            >
              <img alt="" src={shareFacebook} />
            </a>
          </div>
          <div className={styles.followIcon}>
            <a
              href="https://www.instagram.com/cardsnacks/"
              onClick={handleFollowInstagram}
              target="_blank"
              rel="noreferrer"
            >
              <img alt="" src={shareInstagram} />
            </a>
          </div>
          <div className={styles.followIcon}>
            <a
              href="https://twitter.com/CardSnacks"
              onClick={handleFollowTwitter}
              target="_blank"
              rel="noreferrer"
            >
              <img alt="" src={shareTwitter} />
            </a>
          </div>
        </div>
      </div>
      <div className={styles.download}>
        <div className={styles.downloadTitle}>
          Want to create
          <br />
          your own cards?
        </div>
        <div className={styles.downloadLink}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            className={styles.buttonAndroidMarket}
            onClick={handleDownloadAndroid}
            href="https://play.google.com/store/apps/details?id=mobigram.cardsnacks"
          >
            <img alt="" src={downloadAndroid} />
          </a>
        </div>
        {false && (
          <div className={styles.downloadLinkOld}>
            <a
              onClick={handleDownloadAndroid}
              href="https://play.google.com/store/apps/details?id=mobigram.cardsnacks"
            >
              get the app
            </a>
          </div>
        )}
      </div>
    </div>
  );
});

export default DownloadAndroid;
